// extracted by mini-css-extract-plugin
export var clickableWrapper = "_1y-2";
export var placeholderIcon = "_1y-3";
export var thumbnailCanvas = "_1y-1";
export var thumbnailWrapper = "_1y-0";